import React, { useCallback, useEffect, useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import clsx from 'clsx';
import StudioModal from '../StudioModal';
import { studioModalStyles } from '../styles';
import { changeZindex } from '../../intercom/lightHouse';
import lightHouseArticles from '../../../configs/lightHouseArticles';

type Props = {
  open: boolean;
  closeHandler: ()=>void;
};
export default function StudioNoCamerasModal({ open, closeHandler }: Props) {
  const classes = studioModalStyles();
  const [isInfoTroubleOpen, setIsInfoTroubleOpen] = useState<boolean>(false);

  const switchInfoTrouble = useCallback(() => {
    setIsInfoTroubleOpen(true);
    closeHandler();
  }, [setIsInfoTroubleOpen, closeHandler]);

  const closeModal = useCallback(() => {
    closeHandler();
    setIsInfoTroubleOpen(false);
  }, [closeHandler, setIsInfoTroubleOpen]);

  const noCameraModalHelpHandler = useCallback(() => {
    if (window.Lighthouse) {
      changeZindex();
      window.Lighthouse.navigate('article', lightHouseArticles.cameraTrouble);
    }
  }, []);

  useEffect(() => {
    if (window.hdlh) {
      const defaultShow = window.hdlh.onShow;
      const defaultHide = window.hdlh.onHide;
      window.hdlh.onShow = () => {
        if (defaultShow) {
          defaultShow();
        }
      };
      window.hdlh.onHide = () => {
        if (defaultHide) {
          defaultHide();
        }
      };
      return () => {
        if (window.hdlh) {
          window.hdlh.onShow = defaultShow;
          window.hdlh.onHide = defaultHide;
        }
      };
    }
  }, [setIsInfoTroubleOpen]);

  useEffect(() => {
    if (window.Lighthouse && window.hdlh) {
      if (!isInfoTroubleOpen) {
        window.Lighthouse.hide();
        window.hdlh.onHide && window.hdlh.onHide();
      } else {
        noCameraModalHelpHandler();
        window.hdlh.onShow && window.hdlh.onShow();
      }
    }
  }, [isInfoTroubleOpen, noCameraModalHelpHandler]);

  return (
    <StudioModal
      open={open}
      title="No cameras were detected through this browser"
      onClose={closeHandler}
      text="To learn more about this issue view our help page."
    >
      <Grid container alignItems="center" justify="space-between">
        <Button className={clsx(classes.button, 'cancel-neutral')} onClick={switchInfoTrouble}>
          Help
        </Button>
        <Button className={clsx(classes.button, 'cancel-neutral')} onClick={closeModal}>
          OK
        </Button>
      </Grid>
    </StudioModal>
  );
}
